function LoginButton(props) {
  return (
    <button className="login-btn" onClick={props.onClick}>
      Log In
    </button>
  );
}

export default LoginButton;